// GridList.jsx
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import AppDispatcher from '../../dispatchers/AppDispatcher'

import DeviceCompact from './Navigation/DeviceCompact'
import styles from '../../../css/devicePage.module.css'

const GridList = ({ devices, sort, selectMode, tileInfo, selectedStateAll, callback, onSelectionChange }) => {
  const [selectedState, setSelectedState] = useState({})
  const [stateArrayCreated, setStateArrayCreated] = useState(false)
  const [currentSelectMode, setCurrentSelectMode] = useState(selectMode)

  // Handle props changes (equivalent to componentWillReceiveProps)
  useEffect(() => {
    if (
      stateArrayCreated === false &&
      devices &&
      Array.isArray(devices)
    ) {
      const devicesState = {}
      devices.forEach((device) => {
        devicesState[device.id] = false
      })
      setSelectedState(devicesState)
      setStateArrayCreated(true)
      setCurrentSelectMode(selectMode)
    }
  }, [devices, stateArrayCreated, selectMode])

  useEffect(() => {
    if (selectMode !== currentSelectMode) {
      if (selectMode === false) {
        const devicesState = {}
        devices.forEach((device) => {
          devicesState[device.id] = false
        })
        setSelectedState(devicesState)
        setStateArrayCreated(true)
        setCurrentSelectMode(selectMode)
      } else {
        setCurrentSelectMode(selectMode)
      }
    }
  }, [selectMode, currentSelectMode, devices])

  useEffect(() => {
    if (selectedStateAll) {
      setSelectedState(selectedStateAll)
    }
  }, [selectedStateAll])

  const selectFunction = (e, id, enableRpm) => {
    if ((tileInfo === 'rpm' && enableRpm) || (tileInfo === 'default')) {
      if (selectMode) {
        e.preventDefault()
        const newSelectedState = { ...selectedState }
        newSelectedState[id] = !newSelectedState[id]
        setSelectedState(newSelectedState)
        if (onSelectionChange) {
          onSelectionChange(newSelectedState)
        }

        if (newSelectedState[id]) {
          AppDispatcher.dispatch({
            action: 'selected-device-add',
            id,
          })
        } else {
          AppDispatcher.dispatch({
            action: 'selected-device-remove',
            id,
          })
        }
      }
    }
    if (callback) {
      callback()
    }
  }

  let value1 = 'physical'
  let value2 = 'deviceNumber'
  let direction = '1'
  if (sort) {
    value1 = sort.value1
    value2 = sort.value2
    direction = sort.direction
  }

  // Create a copy of devices array to avoid mutating props
  const sortedDevices = [...devices]

  if (value2 === null) {
    sortedDevices.sort((a, b) => {
      if (a[value1] > b[value1]) {
        return 1 * direction
      }
      if (a[value1] < b[value1]) {
        return -1 * direction
      }
      // a must be equal to b
      return 0
    })
  } else {
    sortedDevices.sort((a, b) => {
      try {
        if (a[value1][value2] > b[value1][value2]) {
          return 1 * direction
        }
        if (a[value1][value2] < b[value1][value2]) {
          return -1 * direction
        }
      } catch (error) {
        console.log(error)
      }
      // a must be equal to b
      return 0
    })
  }

  const deviceCompacts = []
  const selectFunctionHandler = selectFunction

  sortedDevices.forEach((device) => {
    let selectedStateDevice = selectedState[device.id]
    let enableRpm = null
    if (
      device.interface_versioned &&
      device.interface_versioned.data &&
      device.interface_versioned.data.primaryPage.settingTypes
    ) {
      enableRpm = device.interface_versioned.data.primaryPage.settingTypes.includes('rpmTarget')
    } else if (
      device.interface &&
      device.interface.primaryPage.settingTypes
    ) {
      enableRpm = device.interface.primaryPage.settingTypes.includes('rpmTarget')
    }
    if (selectMode === false) { selectedStateDevice = false }
    if (typeof device.address === 'string' && device.address.length > 0) {
      deviceCompacts.push(
        <DeviceCompact
          device={device}
          key={device.id}
          selected={(e) => { selectFunctionHandler(e, device.id, enableRpm) }}
          selectedState={selectedStateDevice}
          tileInfo={tileInfo}
          enableRpm={enableRpm}
        />
      )
    }
  })

  return (
    <div>
      <div className={styles.tileContainer}>
        {deviceCompacts}
      </div>
    </div>
  )
}

GridList.propTypes = {
  selectMode: PropTypes.bool,
  devices: PropTypes.array,
  sort: PropTypes.object,
  tileInfo: PropTypes.string,
  selectedStateAll: PropTypes.object,
  callback: PropTypes.func,
  onSelectionChange: PropTypes.func,
}

export default GridList
